import { render } from "./DepositMethodsGridMalawi.vue?vue&type=template&id=c3ebd190&scoped=true"
import script from "./DepositMethodsGridMalawi.vue?vue&type=script&lang=js"
export * from "./DepositMethodsGridMalawi.vue?vue&type=script&lang=js"

import "./DepositMethodsGridMalawi.vue?vue&type=style&index=0&id=c3ebd190&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ebd190"]])

export default __exports__